var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVegetarian(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "white",
    stroke: "#1677ff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.36823 22.3103C7.28346 20.8843 6.67035 18.4247 7.15842 16.5142C8.43606 11.5129 14.4433 11.4818 17.522 8.51404C18.8511 7.23282 18.8447 6.95098 19.3596 7.00653C20.1701 7.09396 21.0474 9.68347 21.3 11.3146C21.6972 13.8799 22.0547 17.586 19.2565 20.8318C16.52 24.0059 12.3454 24.3466 9.36823 22.3103Z",
    fill: "#1677ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71191 24.9998C8.63086 24.9998 8.54828 24.9889 8.4667 24.966C7.98564 24.8307 7.70562 24.3314 7.8407 23.8506C8.47035 21.6105 10.7905 19.6405 11.2492 19.2682C11.5625 19.0145 11.8648 18.788 12.1599 18.5671C13.2467 17.7538 14.1055 17.1115 15.0193 15.4189C15.2567 14.9797 15.8048 14.8152 16.2449 15.0532C16.6844 15.2906 16.8485 15.8392 16.6111 16.2787C15.5076 18.3212 14.4078 19.1441 13.2436 20.0153C12.9667 20.2226 12.6825 20.4351 12.389 20.673C11.5344 21.3663 9.9816 22.9189 9.58208 24.34C9.46986 24.739 9.10675 24.9998 8.71191 24.9998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegetarian);
export default __webpack_public_path__ + "static/media/Vegetarian.23f4b0ec391661667b5d41b06b7d2529.svg";
export { ForwardRef as ReactComponent };